import { render, staticRenderFns } from "./ScrollX.vue?vue&type=template&id=68f4b999&scoped=true"
import script from "./ScrollX.vue?vue&type=script&lang=js"
export * from "./ScrollX.vue?vue&type=script&lang=js"
import style0 from "./ScrollX.vue?vue&type=style&index=0&id=68f4b999&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f4b999",
  null
  
)

export default component.exports